"use client";
import Link from "next/link";
import {useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {
	Article,
	blogPostsSwiperOptions,
	ArticlesShortProps,
	filterAndLimitArticles,
	getArticleImagePath, formatArticleData,
} from "@/shared/pages/articlesShared";
import {consts} from "@/shared/commonShared";
import ExportedImage from "next-image-export-optimizer";


export default function ArticlesShort({ tags, title, classes, limit, articles, onlyFeatured }: ArticlesShortProps) {
	const [posts] = useState<Article[]>(
		articles ? filterAndLimitArticles(articles, tags, limit, onlyFeatured) : []
	);

	/*
	useEffect(() => {
		setPosts(filterAndLimitArticles(articles || [], tags, limit, true));
	}, [articles, tags, limit]);*/

	return (
		<section className={"section-blog-4 pb-40 "+classes+" py-"+consts.PADDING}>
			<div className="container">
				<div className="w-100 text-center">
					<div
						className="d-flex align-items-center justify-content-center bg-primary-soft border border-2 border-white d-inline-flex rounded-pill px-4 py-2"
						data-aos="zoom-in"
						data-aos-delay={100}
					>
						<ExportedImage
							src="/assets/imgs/dots.png"
							alt="decorative dots"
							width={24}
							height={24}
						/>
						<span className="tag-spacing fs-7 fw-bold text-linear-2 ms-2 text-uppercase">
							From Blog
						</span>
					</div>
				</div>
				{title && (<h3
					className={"ds-3 fw-regular text-center my-"+consts.PADDING_SMALL}
					dangerouslySetInnerHTML={{ __html: title }}
				/>)}
				<div className={"row align-items-center mt-"+consts.PADDING+" mb-"+consts.PADDING_SMALL}>
					<div className="col-12 col-auto mt-md-0 text-end">
						<Link href="/blog" className="ms-md-5 fw-bold text-primary">
							See all articles
							<svg
								className="ms-2"
								xmlns="http://www.w3.org/2000/svg"
								width={24}
								height={14}
								viewBox="0 0 24 14"
								fill="none"
							>
								<path
									className="fill-dark"
									d="M17.4177 0.417969L16.3487 1.48705L21.1059 6.24429H0V7.75621H21.1059L16.3487 12.5134L17.4177 13.5825L24 7.0002L17.4177 0.417969Z"
									fill="black"
								/>
							</svg>
						</Link>
					</div>
				</div>

				<div className="row">
					{/* fixed-height wrapper to avoid layout jump */}
					<div className="position-relative w-100" style={{ minHeight: 360 }}>
						<Swiper
							{...blogPostsSwiperOptions}
							className="swiper slider-1 pt-2 h-auto"
						>
							{posts.map((post) => (
								<SwiperSlide className="swiper-slide h-auto" key={post.id}>
									<div className="h-100 card border-0 position-relative rounded-3 d-inline-flex card-hover shadow-2 blogshort-skeleton-card">
										<ExportedImage
											className="rounded-top-3 blogshort-img object-fit-cover w-100"
											style={{ aspectRatio: "16/9" }}
											src={getArticleImagePath(post.thumbnailUrl)}
											alt={post.title}
											width={400}
											height={225}
											sizes="(max-width: 768px) 100vw, 33vw"
										/>
										<div className="card-body bg-white border border-top-0 rounded-bottom-3 p-3">
											<div className="tags d-flex gap-2">
												{post.tags && post.tags.map((tag, index) => (
													<span key={index} className="tag-spacing fs-8 fs-lg-7 fw-bold text-linear-2 text-uppercase">
										  			{tag}
												</span>
												))}
											</div>
											<div className="text-neutral-500 fs-8 mb-2">
												{formatArticleData(post.createdAt)}
											</div>

											<h6 className="mb-1 mb-2">{post.title}</h6>

											<p>{post.shortContent}</p>
										</div>
										<Link
											href={`/blog/${post.urlSlug}`}
											className="position-absolute bottom-0 start-0 end-0 top-0 z-0"
										/>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>
		</section>
	);
}
